document.addEventListener('DOMContentLoaded', ()=> {
    function handleMenuMode() {
        if(window.innerWidth > 1024) {
            setupHoverMenu();
            setupLanguageMenu();
        } else {
            setupDrawerMenu();
            // setupAccordion('.header .acco-head, .footer .language-head');
            // setupAccordion('.header .acco-head', { autoOpen: true });
        }
        setupAccordion('.footer .acco-head', { autoOpen: true });
        setupAccordion('.accordion .accordion-head');
        setupAccordion('.sec-t-forBegginer .scene-head', { autoOpen: true });
        setupAccordion('.faq-con .faq-question', { autoOpen: true });
        //setupAccordion('.faq-con .faq-question', { updateText: updateFAQText });
        setupAccordion('.product-accordion-content .product-accordion-head');
    }

    // Header Hover Menu
    function setupHoverMenu() {
        const hoverMenuTriggers = document.querySelectorAll('.parent-item');
        hoverMenuTriggers.forEach((hoverMenuTrigger) => {
            const hoverMenu = hoverMenuTrigger.querySelector('.child-con');
            if(hoverMenu) {
                hoverMenuTrigger.addEventListener(('mouseover'), () => {
                    hoverMenu.classList.add('show');
                });
                hoverMenuTrigger.addEventListener(('mouseout'), () => {
                    setTimeout(() => {
                        if(!hoverMenuTrigger.matches(':hover') && !hoverMenu.matches(':hover')) {
                            hoverMenu.classList.remove('show');
                        }
                    }, 200);
                });
            }
        });
    }

    // Header 言語変更ボタン
    function setupLanguageMenu() {
        const languageMenuTrigger = document.querySelector('.language-switcher');
        if (!languageMenuTrigger) return;
        const languageMenu = languageMenuTrigger.querySelector('.language-list');
        if(languageMenu) {
            languageMenuTrigger.addEventListener(('mouseover'), () => {
                languageMenu.classList.add('show');
            });
            languageMenuTrigger.addEventListener(('mouseout'), () => {
                setTimeout(() => {
                    if(!languageMenuTrigger.matches(':hover') && !languageMenu.matches(':hover')) {
                        languageMenu.classList.remove('show');
                    }
                }, 200);
            });
        }
    }

    // Header ドロワーメニュー
    function setupDrawerMenu() {
        const body = document.querySelector('body');
        const drawerBtn = document.querySelector('.drawer-btn');
        const drawerNav = document.querySelector('.header-nav');
        drawerBtn.addEventListener(('click'), () => {
            if(drawerBtn.classList.contains('open')) {
                body.style.overflow = "unset";
                drawerBtn.classList.remove('open');
                drawerNav.classList.remove('open');
                // requestAnimationFrame(function () {
                     
                //  });
            } else {
                body.style.overflow = "hidden";
                drawerBtn.classList.add('open');
                drawerNav.classList.add('open');
                setupAccordion('.header .acco-head', { autoOpen: true });
                setTimeout(function () {
                    drawerNav.scrollTop = 0;
                }, 10);
            }
        });
    }

    // Accordion
    function setupAccordion(selector, options = {}) {
        const triggers = document.querySelectorAll(selector);

        triggers.forEach(trigger => {
            const content = trigger.nextElementSibling;
            if (!content) return;

            // 初期状態を0にする
            content.style.maxHeight = '0';
            content.style.overflow = 'hidden';
            content.style.transition = 'max-height 0.6s ease';

            if (options.autoOpen) {
                trigger.classList.add('slideUp');
                content.classList.add('slideUp');
                content.style.maxHeight = content.scrollHeight + 'px';
            } 

            if (trigger.classList.contains('default-open')) {
                trigger.classList.add('slideUp');
                content.classList.add('slideUp');
                content.style.maxHeight = content.scrollHeight + 'px';
            }

            trigger.addEventListener('click', () => {
                const isOpen = content.classList.contains('slideUp');

                if (isOpen) {
                    content.style.maxHeight = content.scrollHeight + 'px'; // 一度セット
                    requestAnimationFrame(() => {
                        content.style.maxHeight = '0';
                    });
                    trigger.classList.remove('slideUp');
                    content.classList.remove('slideUp');
                } else {
                    trigger.classList.add('slideUp');
                    content.classList.add('slideUp');
                    content.style.maxHeight = content.scrollHeight + 'px';
                }
            });
        });
    }

    // FAQのテキスト更新関数
    function updateFAQText(faqContent, isVisible) {
        if (isVisible) {
            faqContent.textContent = faqContent.dataset.shortText;
            faqContent.style.height = 'calc(1.8em + 2px)';
            faqContent.classList.remove('open');
        } else {
            faqContent.textContent = faqContent.dataset.fullText;
            faqContent.style.height = faqContent.scrollHeight + 'px';
            faqContent.classList.add('open');
        }
    }

    // FAQアコーディオンの処理
    // document.querySelectorAll('.faq-con .faq-answer').forEach((faqContent) => {
    //     const fullText = faqContent.textContent.trim();

    //     const updateShortText = () => {
    //         const screenWidth = window.innerWidth;
    //         let shortText = screenWidth > 1024 ? fullText.slice(0, 88) + '...' : fullText.slice(0, 20) + '...';

    //         faqContent.textContent = shortText;
    //         faqContent.dataset.fullText = fullText;
    //         faqContent.dataset.shortText = shortText;
    //     };

    //     updateShortText();
    //     window.addEventListener('resize', updateShortText);

    //     // FAQのクリックイベント追加（修正ポイント）
    //     faqContent.addEventListener('click', () => {
    //         let isVisible = faqContent.textContent === faqContent.dataset.fullText;
    //         updateFAQText(faqContent, isVisible);
    //     });
    // });

    // コレクションページ 定期便のSlick
    $(".item-slider").slick({slidesToShow:4,slidesToScroll:4,autoplay:!0,autoplaySpeed:4e3,responsive:[{breakpoint:860,settings:{slidesToShow:2,slidesToScroll:2}}]});


    window.addEventListener('load', handleMenuMode);
    // window.addEventListener('resize', handleMenuMode);

});